export default "__VITE_ASSET__15565cc5__"